import React, { useEffect, useState } from "react";

export default function FacilityTable({ apiUrl = "/api/ncd/facility-table" }) {
    const [rows, setRows] = useState([]);

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                const res = await fetch(apiUrl, { cache: "no-store" });
                if (!res.ok) throw new Error();
                const json = await res.json();
                if (!mounted) return;
                setRows(json.rows);
            } catch {
                setRows([
                    {
                        district: "Amravati",
                        block: "B1",
                        facility: "PHC-01",
                        screened: 220,
                        htn: 30,
                        dm: 15,
                        controlled_pct: 70,
                        followup_pct: 80,
                        status: "Active",
                    },
                    {
                        district: "Akola",
                        block: "B2",
                        facility: "PHC-02",
                        screened: 340,
                        htn: 40,
                        dm: 20,
                        controlled_pct: 65,
                        followup_pct: 72,
                        status: "Active",
                    },
                    {
                        district: "Pune",
                        block: "B3",
                        facility: "CHC-01",
                        screened: 180,
                        htn: 25,
                        dm: 12,
                        controlled_pct: 68,
                        followup_pct: 75,
                        status: "Partial",
                    },
                ]);
            }
        })();
        return () => (mounted = false);
    }, [apiUrl]);

    return (
        <div className="card shadow-sm border-0">
            <div className="card-body p-2">
                <h6 className="text-gray-800 fs-6 font-semibold mb-3">
                    Facility-level Summary
                </h6>

                <div className="overflow-x-auto rounded-lg">
                    <table className="min-w-full text-sm text-gray-700">
                        <thead>
                            <tr className="bg-gray-50 text-gray-600 text-xs uppercase tracking-wider border-b border-gray-200">
                                <th className="px-3 py-2 text-left">District</th>
                                <th className="px-3 py-2 text-left">Block</th>
                                <th className="px-3 py-2 text-left">Facility</th>
                                <th className="px-3 py-2 text-left">Screened</th>
                                <th className="px-3 py-2 text-left">HTN</th>
                                <th className="px-3 py-2 text-left">DM</th>
                                <th className="px-3 py-2 text-left">Controlled %</th>
                                <th className="px-3 py-2 text-left">Follow-up %</th>
                                <th className="px-3 py-2 text-center">Status</th>
                            </tr>
                        </thead>

                        <tbody>
                            {rows.map((r, i) => (
                                <tr
                                    key={i}
                                    className={`${i % 2 === 0 ? "bg-white" : "bg-gray-50"
                                        } hover:bg-blue-50 transition-all duration-150`}
                                >
                                    <td className="px-3 py-2 font-medium">{r.district}</td>
                                    <td className="px-3 py-2">{r.block}</td>
                                    <td className="px-3 py-2">{r.facility}</td>
                                    <td className="px-3 py-2 text-right">{r.screened}</td>
                                    <td className="px-3 py-2 text-right">{r.htn}</td>
                                    <td className="px-3 py-2 text-right">{r.dm}</td>
                                    <td
                                        className={`px-3 py-2 text-right font-semibold ${r.controlled_pct >= 70
                                                ? "text-green-600"
                                                : "text-yellow-600"
                                            }`}
                                    >
                                        {r.controlled_pct}%
                                    </td>
                                    <td
                                        className={`px-3 py-2 text-right font-semibold ${r.followup_pct >= 75
                                                ? "text-green-600"
                                                : "text-orange-600"
                                            }`}
                                    >
                                        {r.followup_pct}%
                                    </td>
                                    <td className="px-3 py-2 text-center">
                                        <span
                                            className={`px-2 py-1 rounded-full text-xs font-medium ${r.status === "Active"
                                                    ? "bg-green-100 text-green-700"
                                                    : "bg-yellow-100 text-yellow-700"
                                                }`}
                                        >
                                            {r.status}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {rows.length === 0 && (
                    <div className="text-center text-gray-400 text-sm mt-3">
                        Loading data...
                    </div>
                )}
            </div>
        </div>
    );
}
